import { MinzeElement } from 'minze'

export interface LvcToastCloseIcon {}

export class LvcToastCloseIcon extends MinzeElement {
  html = () => `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.4 20.4C17.3336 17.8217 14.3809 15.1072 11.5516 12.2662M11.5516 12.2662C8.80241 9.50578 6.10736 6.59041 3.59998 3.59998M11.5516 12.2662C14.1517 9.1677 17.2348 6.58123 20.4 3.59998M11.5516 12.2662C8.56369 15.4436 6.37433 17.3065 3.59998 20.4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
    
  `
}
